import { api } from 'services/api'

export async function createPaymentTable(payload) {
  const { data } = await api.post('/paymentTb', payload)

  return data
}
